// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__3lZO0","outlet":"Layout_outlet__tZR07","footer":"Layout_footer__K8scF"};